import {SignupInput} from "../../components/signup/SignupInput";
import * as React from "react";
import { v4 as uuidv4 } from 'uuid';

import './FormElement.pcss';

interface Props {
  label:string;
  invalidReason:string;
  disabled:boolean;
  value:string;
  onChange:(value:string)=>void;
  optional?:boolean;
  type?:'text'|'textarea',
}

export const FormElement = (props:Props) => {
  const uuid = uuidv4();

  return (
      <div className={`form-element${props.invalidReason?' invalid':''}`}>
        <label htmlFor={uuid}>{props.label}</label>
        {props.invalidReason && <p id={`error-${uuid}`} className={'form-element-error'}>{props.invalidReason}</p>}
        {props.type && 'textarea'===props.type ?
          <textarea
              aria-describedby={`error-${uuid}`}
              id={uuid}
              rows={3}
              disabled={props.disabled}
              value={props.value}
              onChange={(e)=>{props.onChange(e.target.value);}}
              className={`${props.invalidReason?'invalid':''}`}
          ></textarea>
        :
          <SignupInput
              aria-describedby={`error-${uuid}`}
              id={uuid}
              required={!props.optional}
              invalid={!!props.invalidReason}
              inputName={uuid}
              placeholder={''}
              disabled={props.disabled}
              value={props.value}
              updateValue={props.onChange}
          />
        }
      </div>
  )
}